import './bootstrap';
import './gallery';

import 'owl.carousel2';

import { addBackToTop } from "vanilla-back-to-top";
import caleandar from './caleandar';

import Vue from 'vue';

// Imports
import VueCarousel from 'vue-carousel';
Vue.use(VueCarousel);

import VueSocialSharing from 'vue-social-sharing';
Vue.use(VueSocialSharing);

import 'viewerjs/dist/viewer.css';
import Viewer from 'v-viewer';
Vue.use(Viewer);

// Components
Vue.component('search-bar', require('./components/SearchBar.vue').default);
Vue.component('go-to-top', require('./components/GoTop.vue').default);

new Vue({
    el: '#app',
});
